export default __webpack_public_path__ + "static/media/aroshell_winter_hat.a06432d0.jpg";